import { createFileRoute } from '@tanstack/react-router';

import { CalendarPage } from '@/features/calendar';

/**
 * `month` and `assigned_to` live in the URL rather than component state, so a
 * link to a month is shareable and the back button steps months.
 *
 * `month` is left undefined when absent rather than defaulted here: the default
 * is the practice's current month, and only the component has the organization
 * timezone needed to work that out.
 */
export const Route = createFileRoute('/_authenticated/calendar')({
  component: CalendarPage,
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/calendar', title: 'Calendar' }],
  }),
  validateSearch: (search: Record<string, unknown>) => ({
    assigned_to: typeof search.assigned_to === 'string' ? search.assigned_to : undefined,
    month: typeof search.month === 'string' && /^\d{4}-\d{2}$/.test(search.month) ? search.month : undefined,
  }),
});
